/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsIcon_viewer = {
    readonly conversations?: {
        readonly metadata: {
            readonly lastUnreadMessageDate: string | null;
        } | null;
    } | null;
    readonly isAutomatedOfferNotificationDisabled: boolean | null;
    readonly " $refType": "NotificationsIcon_viewer";
};
export type NotificationsIcon_viewer$data = NotificationsIcon_viewer;
export type NotificationsIcon_viewer$key = {
    readonly " $data"?: NotificationsIcon_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsIcon_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsIcon_viewer",
  "selections": [
    {
      "alias": "isAutomatedOfferNotificationDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableAutomatedOfferBellNotification"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            }
          ],
          "concreteType": "ConversationConnection",
          "kind": "LinkedField",
          "name": "conversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastUnreadMessageDate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "conversations(filter:\"showUnreadOnly\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'b8a05abd60ae06b355afe3e101ca1ad4';
export default node;
